
let URL_BASE =''
console.log(process.env.NODE_ENV,'所在环境');
const ENV =  process.env.NODE_ENV
if(ENV =='development') {  //测试
    URL_BASE = '/api'
}else if (ENV =='production'){   
    // URL_BASE ="http://116.228.78.26:52800/zhyxypt/"  //测试
    // URL_BASE ="https://shwzoo.techown.com/zhyxypt_test/zhyxypt/" //测试
    URL_BASE =  'https://shwzoo.techown.com/zhyxypt/' //生产
}

const fringService = '/front-service';//中转服务3206
const orderCustomer = "/customer-manager";//旅行社预订平台2010
const baseMember = '/member';//业务管理平台-会员管理3202
const baseScenic = "/base-scenic";//综合管理平台-票务8202
const fileUploadUrl ='/fastdfs';//图片上传
const faceUrl = '/face-service'; // 人脸
const orderInformation ="/information"
const baseNew = 'base-new'
const businessId = 'aeuE2uLpST3uF9NRQkE30w=='
const api = '/capi'
export {
    URL_BASE,
    businessId,
    api,
    fringService,
    baseMember,
    orderCustomer,
    baseScenic,
    fileUploadUrl,
    faceUrl,
    orderInformation,
    baseNew
}
